import React from "react";

import { XExecutableTester } from "../XExecutableTester";

import { DataDefinition } from "../../../rule-engine-core/Common/Data/DataDefinition";
import { StringDataDefinition } from "../../../rule-engine-core/Common/Data/Definitions/StringDataDefinition";
import { BooleanDataDefinition } from "../../../rule-engine-core/Common/Data/Definitions/BooleanDataDefinition";
import { NumberDataDefinition } from "../../../rule-engine-core/Common/Data/Definitions/NumberDataDefinition";
import { FormConfiguration } from "../../../Form/FormConfiguration";
import { HeadingFormControl } from "../../../Form/Controls/Web/HeadingFormControl";
import { XHStackContainer, XStackContainer } from "../../../Form/Containers";
import { TextFormControl } from "../../../Form/Controls/Web/TextFormControl";
import { SwitchFormControl } from "../../../Form/Controls/Web/SwitchFormControl";
import { NumberFormControl } from "../../../Form/Controls/Web/NumberFormControl";
import { ButtonFormControl } from "../../../Form/Controls/Web/ButtonFormControl";
import { StoryNode } from "../../StoryBook/StoryData";

let heading = new HeadingFormControl();
heading.text = "Form Tester";
heading.type = "h3";

let container = new XStackContainer();

let firstName = new TextFormControl();
firstName.label = "first name";
firstName.valueName = "firstName";

let lastName = new TextFormControl();
lastName.label = "last name";
lastName.valueName = "lastName";

let fulltime = new SwitchFormControl();
fulltime.label = "fulltime";
fulltime.valueName = "fulltime";

let age = new NumberFormControl();
age.label = "age";
age.valueName = "age";

container.add(heading);
container.add(firstName);
container.add(lastName);
container.add(fulltime);
container.add(age);

let buttonContainer = new XHStackContainer();

let button = new ButtonFormControl();
button.label = "Submit";
let button2 = new ButtonFormControl();
button2.label = "Cancel";

buttonContainer.add(button);
buttonContainer.add(button2);

let form = new FormConfiguration([container, buttonContainer]);

let def = new DataDefinition();
def.fields.push(new StringDataDefinition("firstName"));
def.fields.push(new StringDataDefinition("lastName"));

def.fields.push(new BooleanDataDefinition("fulltime"));
def.fields.push(new NumberDataDefinition("age"));

form.inputData = def;

export const FormTester = [
    new StoryNode(
        () => {
            return <XExecutableTester executable={form} />;
        },
        "Shared",
        "Tester",
        "Form",
        "Default",
    ),
];
